var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6H2.5V20C2.5 21.1 3.4 22 4.5 22H18.5V20H4.5V6ZM20.5 2H8.5C7.4 2 6.5 2.9 6.5 4V16C6.5 17.1 7.4 18 8.5 18H20.5C21.6 18 22.5 17.1 22.5 16V4C22.5 2.9 21.6 2 20.5 2ZM20.5 16H8.5V4H20.5V16ZM14.01 10.16C14.42 9.43 15.19 9 15.64 8.36C16.12 7.68 15.85 6.42 14.5 6.42C13.62 6.42 13.18 7.09 13 7.65L11.63 7.08C12.01 5.96 13.02 5 14.49 5C15.72 5 16.57 5.56 17 6.26C17.37 6.86 17.58 7.99 17.01 8.83C16.38 9.76 15.78 10.04 15.45 10.64C15.32 10.88 15.27 11.04 15.27 11.82H13.75C13.76 11.41 13.69 10.74 14.01 10.16ZM13.45 13.95C13.45 13.36 13.92 12.91 14.5 12.91C15.09 12.91 15.54 13.36 15.54 13.95C15.54 14.53 15.1 15 14.5 15C13.92 15 13.45 14.53 13.45 13.95Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.6273281113dd0e223956c0749cdced7e.svg";
export { ForwardRef as ReactComponent };